import type { IconName } from "../components/Icon";

export type SocialLink = {
  readonly label: string;
  readonly detail: string;
  readonly href: `https://${string}`;
  readonly icon: IconName;
};

export type WorkArea = {
  readonly id: string;
  readonly title: string;
  readonly description: string;
};

export type Project = {
  readonly name: string;
  readonly href?: `https://${string}`;
  readonly relationship: "Site" | "Brand" | "Partner";
  readonly description: string;
  readonly skills?: readonly string[];
  readonly contribution?: string;
  readonly placeholder?: boolean;
  readonly image?: {
    readonly src: `/${string}`;
    readonly alt: string;
    readonly fit?: "cover" | "contain";
  };
};

// Add public projects here. Entries without a URL still show their description.
// Put brand images in public/brands and use /brands/filename.webp as the src.
export const projects: readonly Project[] = [
  {
    name: "Cheatstore",
    relationship: "Partner",
    description: "Industry standard cheat reselling platform. Cheats sold for video games.",
    contribution:
      "Handling fullstack development and infrastructure. Naturally working with such a volatile customer base and product, creativity is a must. Working together with Cheatstore and their leadership-team; it makes for a very fun and challenging environment.\n\nThe required hosting setup comes with significant network constraints, including high packet loss. Working within those limits has pushed us to optimize extensively across the frontend, backend, and infrastructure, reducing delays and minimizing how much those network issues affect the customer experience.",
    skills: [
      "DDoS mitigation",
      "Spring Boot",
      "Reverse proxies",
      "Rate limiting",
      "Monitoring",
      "Microservices",
      "Payment gateways",
      "OpenVPN",
      "Cloudflare",
      "CI/CD (Jenkins)",
      "Docker",
      "React",
      "Docker",
      "Payment routing",
      "Redundancy",
      "Scalable architecture",
      "Typescript",
      "PostgreSQL",
      "Linux",
      "Custom CRM system",
      "Custom support flow",
      "AI integration",
    ],
    image: {
      src: "/brands/cheatstore.svg",
      alt: "CheatStore logo",
      fit: "contain",
    },
  },
  {
    name: "Vaccine",
    relationship: "Partner",
    description: "A modern cheat seller.",
    contribution:
      "Similar setup to Cheatstore but with a more stand-alone approach. Working on infrastructure such as load balancers, solving complex backend solutions and keeping the site up and running.",
    skills: [
      "DDoS mitigation",
      "Spring Boot",
      "Reverse proxies",
      "Rate limiting",
      "Monitoring",
      "Microservices",
      "Payment gateway",
      "OpenVPN",
      "Cloudflare",
      "Apache Pulsar",
      "Custom crypto solutions",
      "CI/CD (Jenkins)",
      "Docker",
      "Typescript",
      "PostgreSQL",
      "Linux",
    ],
    image: {
      src: "/brands/vaccine.png",
      alt: "Vaccine logo",
      fit: "contain",
    },
  },
  {
    name: "ThoraxGaming",
    relationship: "Partner",
    description:
      "A big gaming network starting from a small minecraft server. Ran by my dear friend while I handled everything else IT operations-wise (and later on as a administrative role) for probably close to 5-10 years, sadly was later disbanded due to everyone being at different point in their lives :(. Probably single-handedly the reason I got into development to begin with. Shoutout lidingo3",
    contribution: "Managed over 15 different game servers ranging from CS:GO Jailbreak, Surf, MG and so on. We brought several industry standards into the gamemodes, sponsors of community projects such as gamebanana. It was hard back in the days to see one of our servers under 40 players." +
    "\r\n" +
    "\r\n" +
    "We also dabbled with ex. Minecraft, GTA: SA and so on. We had our own E-Sports teams and also had sponsors such as pussyenergydrinks, larsviken chips, eset antivirus and a few other. I also was the one to recommend rejecting a partnership with discord because, \"skype will never die lol, no one will use discord\".",
    skills: [
      "C#",
      "Java",
      "Bukkit/Spigot",
      "Linux",
      "Monitoring",
      "PHP",
      "HTML",
      "CSS",
      "Cloudflare",
      "Bungeecoord",
      "Sourcepawn",
      "MySQL",
      "SQLite",
      "Forge"
    ],
    image: {
      src: "/brands/thoraxgaming.png",
      alt: "ThoraxGaming logo",
      fit: "contain",
    },
  },
];

export const siteConfig = {
  name: "Kalkonen",
  domain: "kalkonen.world",
  established: 2018,
  title: "Kalkonen | Sites, infrastructure & automation",
  description:
    "I mostly work with web development nowadays, includes stuff such as DDoS mitigation, CI/CD pipelines and keeping things \"sigma\", as the kids would say.",
  intro: "",
  work: {
    heading: "Who in the sigma ARE YOU?",
    intro:
      "I'm a male developer 20-30~ years of age living in Sweden who first dabbled with PHP at 8 years of age (actively running my own habbo retros for educational purposes, hamachi shoutout until I learned portforwarding), so excuse me for my faults. PHP at a young age is not recommended." +
      "\r\n" +
      "\r\n" +
      "After growing up a bit, I realized at 10, Java was the way. I did a lot other stuff besides that and did dabble in a lot different fields though, such as C# and PHP again (smh). In the later years I also picked up a lot of knowledge and even coded some of my own game memory modification software (cheats ok), however I also was coding on and off on my own cheats for Minecraft since ~11 years old, I never released builds publicly really though, it was more about the hunt than the prize." +
      "\r\n" +
      "\r\n" +
      "I highlighted some of the areas I work a lot with. But I work with very broad customer-base."
    ,
    areas: [
      {
        id: "fullstack-development",
        title: "Full-Stack Development",
        description:
          "Building complete applications from frontend/backend to full desktop applications. I work on the entire development lifecycle to deliver robust and scalable solutions.",
      },
      {
        id: "ddos-mitigation",
        title: "DDoS mitigation",
        description:
          "The projects I work with, usually land on the more \"volatile\" type of users, which requires very analytical and thinking one step ahead of the attackers. Reverse proxies, rate-limits, proper WAF rules is just the beginning.",
      },
      {
        id: "blockchain",
        title: "Blockchain Development",
        description:
          "Experienced with blockchain technologies, running own nodes, optimizing and validating sub-second solana transaction confirmations, writing own RPC wrapper for custom impl functions and similar fun stuff.",
      },
      {
        id: "Passionated",
        title: "Passion and work ethic",
        description:
          "I take pride in my work and if a emergency hits, I will be there to fix or help assist fixing it. I have a very strong work ethic and I take pride in my work. I will always go the extra mile to ensure that the job is done right.",
      },
    ] satisfies readonly WorkArea[],
  },
  projects: {
    heading: "Experiences",
    intro: "Some of the projects I've worked on and the skills I used to make them happen. This list is not meant to list every partner, but rather the partners that has really stood out to me and my work as **Kalkonen**.",
  },
  socialLinks: [
    {
      label: "Steam",
      detail: "Profile",
      href: "https://steamcommunity.com/id/kalkonendotworldxdxd",
      icon: "steam",
    },
    {
      label: "YouTube",
      detail: "Channel",
      href: "https://www.youtube.com/channel/UCjaeZYSUqyqtVttF-o1AibA",
      icon: "youtube",
    },
    {
      label: "Discord",
      detail: "Community",
      href: "https://discord.gg/gNah8dV",
      icon: "discord",
    },
  ] satisfies readonly SocialLink[],
} as const;
